export { default as filesGetSrc } from "./getSrc";
